import { install } from './helper';
var env = {
    mode: 'production',
    baseApi: '//api-lv.aquanliang.com',
    domain: 'www-game.aquanliang.com',
    assetsDomain: 'www-game.aquanliang.com',
    skinConfigPath: '//www-game.aquanliang.com/app/root-config-ee/locales/skin.production.lv.json',
};
export default install(env);
